import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import InputAdornment from '@material-ui/core/InputAdornment';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import MaskCpfCnpj from '../../../util/SimpleMask/MaskCpfCnpj'
import TermosDialog from './TermosDialog';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="http://dev3.itinovacao.org.br/">
        BOAZ
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    padding: theme.spacing(2),
  },
  linkTermos: {
    marginTop: theme.spacing(-2)
  }
}));

export default function SignUp(props) {
  const classes = useStyles();

  const [cpfCnpj, setCpfCnpj] = React.useState('');
  const [firtName, setFirtName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [senha, setSenha] = React.useState('');

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [checkedTermos, setCheckedTermos] = React.useState(false);
  const [isCnpj, setIsCnpj] = React.useState(false);

  const checkTermos = (event) => {
    setCheckedTermos(event.target.checked);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openTermos, setOpenTermos] = React.useState(false);

  const clickOpenTermos = () => {
    setOpenTermos(true);
  };

  const clickCloseTermos = () => {
    setOpenTermos(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  function maskCpfCnpj(e) {
    let v = e.target.value
    v = MaskCpfCnpj(v)
    setCpfCnpj(v);
    if (v.length > 14) {
      setIsCnpj(true)
    } else {
      setIsCnpj(false)
    }
  }

  onsubmit = (event) => {
    event.preventDefault()
    if (checkedTermos) {
      const regexSenha = /(?=^.{8,}$)((?=.*\d)(?=.*\w+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (regexSenha.exec(senha)) {
        props.onSubmit(cpfCnpj, firtName, lastName, email, senha)
      } else {
        props.dispatch({
          type: 'OPEN_ALERT_DIALOG',
          title: 'Cadastro',
          description: 'A senha não atende os critérios.'
        })
      }
    } else {
      props.dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Cadastro',
        description: 'Você precisa concordar com os termos.'
      })
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Cadastro
        </Typography>
        <form className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="cpfcnpj"
                label="CPF/CNPJ"
                name="cpfcnpj"
                type="text"
                onChange={(e) => maskCpfCnpj(e)}
                value={cpfCnpj}
                autoFocus
              />
            </Grid>
            {isCnpj ?
              <Grid item xs={12}>
                <TextField
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="Nome da empresa"
                  onChange={(e) => setFirtName(e.target.value)}
                  value={firtName}
                />
              </Grid>

              :
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="firstName"
                    variant="outlined"
                    required
                    fullWidth
                    id="firstName"
                    label="Primeiro Nome"
                    onChange={(e) => setFirtName(e.target.value)}
                    value={firtName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="lastName"
                    label="Ultimo Nome"
                    name="lastName"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                  />
                </Grid>
              </>
            }
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="cemail"
                label="E-mail"
                name="cemail"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </Grid>
            <Grid item xs={12}>

              <TextField
                variant="outlined"
                required
                fullWidth
                name="cpassword"
                label="Senha"
                type="password"
                id="cpassword"
                onChange={(e) => setSenha(e.target.value)}
                autoComplete="new-password"
                value={senha}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClick}>
                        <InfoIcon />
                      </IconButton>
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'center',
                        }}
                      >
                        <Typography className={classes.typography}>
                          A senha deve conter: <br />
                          • um caractere maiúsculo <br />
                          • um caractere minúsculo <br />
                          • um numero <br />
                          • minimo 8 caracteres
                        </Typography>
                      </Popover>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedTermos}
                    onChange={checkTermos}
                    value="allowExtraEmails"
                    color="primary" />
                }
                label={`Eu concordo com os termos e condições.`}
              />
            </Grid>
            <Grid
              container
              justify="flex-end"
              alignItems="center"
            >
              <Link
                className={classes.linkTermos}
                variant="body2"
                onClick={clickOpenTermos}
              >
                Ver os termos.
            </Link>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Cadastrar
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/login" variant="body2">
                Você ja tem cadastro? Login
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
      <TermosDialog open={openTermos} close={clickCloseTermos} checkTermos={setCheckedTermos} />
    </Container>
  );
}